module.exports = __webpack_public_path__ + "static/media/icon_optometry.f01b2628.svg";